// Telas reais dos apps (WebP otimizado), usadas na Home e nas páginas de projeto
import revyouScreen from '../assets/revyou/app/jogo.webp';
import psicoidScreen from '../assets/psicoid/app/home.webp';
import egScreen from '../assets/home/eg-treinos.webp';
import meuAtalhoScreen from '../assets/home/meu-atalho.webp';

export const PROJECTS = [
  {
    slug: 'psicoid',
    screen: psicoidScreen,
    platforms: ['iOS', 'Android', 'Web'],
    name: 'PsicoID',
    tagline: 'Gestão de consultório para psicólogos',
    desc: 'A rotina clínica num app só: a profissional abre a agenda, o paciente marca sozinho, e registros de sessão, prontuário e financeiro ficam no mesmo lugar.',
    tags: ['iOS', 'Android', 'Web'],
    accent: '#3b46f1',
    path: '/apps/psicoid',
  },
  {
    slug: 'revyou',
    screen: revyouScreen,
    platforms: ['Web', 'iOS', 'Android'],
    name: 'Revyou',
    tagline: 'Diário de games e filmes',
    desc: 'Rede para registrar, avaliar e relembrar tudo o que você joga e assiste: biblioteca, reviews, listas, feed de amigos e importação de Steam, PSN e Xbox.',
    tags: ['Web', 'iOS', 'Android'],
    accent: '#7c3aed',
    // estrela multicolor: verde, roxo, vermelho e amarelo
    glow: 'radial-gradient(circle at 30% 30%, rgba(28,217,127,0.55), transparent 56%), radial-gradient(circle at 72% 28%, rgba(124,58,237,0.6), transparent 56%), radial-gradient(circle at 32% 74%, rgba(239,68,68,0.5), transparent 56%), radial-gradient(circle at 74% 72%, rgba(245,158,11,0.55), transparent 56%)',
    path: '/apps/revyou',
  },
  {
    slug: 'eg-treinos',
    screen: egScreen,
    platforms: ['iOS', 'Android'],
    name: 'EG Treinos',
    tagline: 'Gestão para personal trainers',
    desc: 'Organiza a agenda de personal trainers e entrega os treinos de forma simples e acessível para cada aluno.',
    tags: ['iOS', 'Android', 'Fitness'],
    accent: '#ef4444',
    path: '/apps/eg-treinos',
  },
  {
    slug: 'meu-atalho',
    screen: meuAtalhoScreen,
    platforms: ['iOS', 'Android'],
    name: 'Meu Atalho',
    tagline: 'Produtividade & teclado',
    desc: 'Crie, organize e copie atalhos de texto com rapidez: categorias, busca e teclado personalizado.',
    tags: ['iOS', 'Android', 'Produtividade'],
    accent: '#10b981',
    path: '/apps/meu-atalho',
  },
];
